import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class SectionWhiteFirst extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      color: 'white'
    };
    this.sectionElem = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.listenScrollEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenScrollEvent);
  }

  listenScrollEvent = e => {
    const elemPositionY =
      Number(this.sectionElem.current.getBoundingClientRect().top) - 40;
    if (Math.round(elemPositionY) < 0) {
      this.setState(
        {
          color: 'blue'
        },
        () => {
          this.props.logoColor(this.state.color);
        }
      );
    } else {
      this.props.logoColor(this.props.initialLogoColor || 'white');
    }
  };
  
  render() {
    return <div ref={this.sectionElem} />;
  }
}

export default SectionWhiteFirst;

SectionWhiteFirst.defaultProps = {
  logoColor: () => {},
  initialLogoColor: null,
};
SectionWhiteFirst.propTypes = {
  logoColor: PropTypes.func,
  initialLogoColor: PropTypes.any,
};
